// Escurece (amount < 0) ou clareia (amount > 0) uma cor hex. Serve para gerar
// os estados de hover/pressionado dos botões a partir da cor da loja.
//
// `color-mix()` faria isso em CSS, mas não existe nos WebViews antigos da
// frota; por isso a conta é feita aqui, uma vez, quando a loja carrega.
// Cor que não for hex (#rgb ou #rrggbb) volta intacta.
export default function shadeColor(color, amount) {
  const rgb = parseHex(color);
  if (!rgb) {
    return color;
  }

  const target = amount < 0 ? 0 : 255;
  const ratio = Math.min(Math.abs(amount), 1);
  const mixed = rgb.map((c) => Math.round(c + (target - c) * ratio));
  return `#${mixed.map((c) => c.toString(16).padStart(2, "0")).join("")}`;
}

// A mesma cor com transparência, para fundos suaves (chip ativo, selos).
export function alphaColor(color, alpha) {
  const rgb = parseHex(color);
  if (!rgb) {
    return color;
  }

  return `rgba(${rgb.join(", ")}, ${alpha})`;
}

function parseHex(color) {
  const match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec((color || "").trim());
  if (!match) {
    return null;
  }

  const hex =
    match[1].length === 3
      ? match[1]
          .split("")
          .map((c) => c + c)
          .join("")
      : match[1];
  return [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16));
}
